import type { ShopInfoQueryResponse } from '../shop/queries/useShopInfoQuery';

import { isTokenExpired } from './isTokenExpired';
import { getConfig } from '~/config/environment';
import { fetchFromAPI } from './restApiFetch';
import { useShopStore } from '~/stores/shop';

// GraphQL client
export const GP_V7_API_URL = getConfig('URL')?.GP_V7_API_URL;
export const GRAPHQL_URL = `${GP_V7_API_URL}graphql/query`;
let awaitRefreshToken: Promise<any> | null = null;

export const requestMiddleware: any = async (request: any) => {
  const shopStoreState = useShopStore.getState();

  let token = shopStoreState.shopInfo?.token;
  let shopID = shopStoreState.shopInfo?.shopID;

  if (!token) throw new Error('Token is required');
  if (awaitRefreshToken) await awaitRefreshToken;

  if (isTokenExpired(token)) {
    awaitRefreshToken = new Promise((resolve, reject) => {
      fetchFromAPI('/api/shop', { method: 'GET' })
        .then((res: ShopInfoQueryResponse) => {
          token = res?.token ?? '';
          shopID = res?.shopID ?? '';
          shopStoreState.setShopAuth({ shopID, token });
          resolve(res);
        })
        .catch(() => {
          reject(new Error('Failed to refresh token'));
        });
    });
    await awaitRefreshToken;
    awaitRefreshToken = null;
  }

  const requestBody = JSON.parse(request.body || '{}');
  const operationName = requestBody.operationName;
  const urlWithOperation = new URL(GRAPHQL_URL);
  urlWithOperation.searchParams.set('operation', operationName);

  const headers: Record<string, any> = {
    'Content-Type': 'application/json',
    Authorization: `Token ${token}`,
    'X-GemX-Shop-ID': shopID,
  };

  return {
    ...request,
    credentials: 'omit',
    url: urlWithOperation.href,
    headers,
  };
};
